import MenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import CheckIcon from '@mui/icons-material/Check';
import React from 'react';

type MenuItemWithCheckProps = Omit<MenuItemProps, 'ref' | 'className' | 'classes'>;

const MenuItemWithCheck = ({ children, ...rest }: MenuItemWithCheckProps) => {
  return (
    <MenuItem
      className="d-flex align-items-center"
      classes={{ selected: 'tw-font-bold tw-bg-none' }}
      {...rest}
    >
      {children}
      {rest.selected && <CheckIcon fontSize="small" color="inherit" className="ml-3" />}
    </MenuItem>
  );
};
export default MenuItemWithCheck;
